import React, { Fragment, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { getDomElement } from 'Utils/Browser';

import './Modal.css';

export function Modal({
  children,
  isShowing,
  onClose,
  customClass = '',
  crossColor = 'black',
  renderCloseOutsideWindow = false,
  hideCloseButton = false,
  modernLayout,
}) {
  useEffect(() => {
    if (isShowing) document.body.classList.add('hideOverflow');
    return function unMountModal() {
      document.body.classList.remove('hideOverflow');
    };
  }, [isShowing]);

  const closeButtonSrc = modernLayout
    ? `/account/static/images/close.svg`
    : `/account/static/images/cross-mark-${crossColor}.svg`;

  const closeButton = (
    <div className="modalClose" onClick={onClose} role="button">
      <img className="modalCloseButton" src={closeButtonSrc} alt="Close" />
    </div>
  );

  return isShowing
    ? createPortal(
        <Fragment>
          <div className="modalOverlay" onClick={onClose} role="button" />
          {!hideCloseButton && renderCloseOutsideWindow && closeButton}
          <div
            className={`modalWrapper ${modernLayout && 'modernLayout'} ${customClass}`}
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
          >
            <div className="modal">
              {!hideCloseButton && !renderCloseOutsideWindow && closeButton}
              {children}
            </div>
          </div>
        </Fragment>,
        getDomElement('#modalRoot')
      )
    : null;
}
